module.exports = __webpack_public_path__ + "img/cheerios.c06f60ca.png";